export default __webpack_public_path__ + "locales/pl/Translations.json?hash=41cb14f1b8a89be1e266d607224c3922";